import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=c8980bcc&scoped=true&lang=pug&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=c8980bcc&lang=scss&scoped=true&"
import style1 from "./Toolbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8980bcc",
  null
  
)

export default component.exports